import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';

import { mermaidEditorWidget } from './editor/widget.js';
import { effects } from './effects.js';
import { MermaidElementView, MermaidInteraction } from './element-view.js';
import { MermaidTool } from './mermaid-tool.js';
import {
  MermaidDomRendererExtension,
  MermaidElementRendererExtension,
} from './renderer/index.js';
import { mermaidToolbarExtension } from './toolbar/config.js';
import { mermaidSeniorTool } from './toolbar/senior-tool.js';

export class MermaidViewExtension extends ViewExtensionProvider {
  override name = 'affine-mermaid-gfx';

  override effect(): void {
    super.effect();
    effects();
  }

  override setup(context: ViewExtensionContext) {
    super.setup(context);
    if (this.isEdgeless(context.scope)) {
      context.register(MermaidElementRendererExtension);
      context.register(mermaidEditorWidget);
      context.register(MermaidElementView);
      context.register(MermaidInteraction);
      context.register(MermaidDomRendererExtension);
      context.register(MermaidTool);
      context.register(mermaidSeniorTool);
      context.register(mermaidToolbarExtension);
    }
  }
}
